import { z } from "zod";

export const generalSettingsSchema = z.object({
  organizationName: z.string(),
  timezone: z.string(),
  dateFormat: z.string(),
  timeFormat: z.string(),
  language: z.string(),
  defaultDashboard: z.string(),
  maintenanceMode: z.boolean(),
  maintenanceMessage: z.string().optional(),
  lastUsedExternalSourceId: z.string().nullable().optional(),
});

export const securityPolicySchema = z.object({
  managedBy: z.literal("workos"),
  requiresWorkosConnection: z.literal(true),
  hostedLogin: z.literal(true),
  hostedUserManagement: z.literal(true),
  managedCapabilities: z.array(z.string()),
  description: z.string(),
});

export const notificationSettingsSchema = z.object({
  emailEnabled: z.boolean(),
  emailServer: z.string().optional(),
  emailPort: z.number().optional(),
  emailSecure: z.boolean().optional(),
  emailFrom: z.string().optional(),
  slackEnabled: z.boolean(),
  slackWebhookUrl: z.string().optional(),
  teamsEnabled: z.boolean(),
  teamsWebhookUrl: z.string().optional(),
  webhookEnabled: z.boolean(),
  webhookUrl: z.string().optional(),
  webhookHeaders: z.any().optional(),
});

const alertRuleSchema = z.object({
  id: z.string(),
  name: z.string(),
  enabled: z.boolean(),
  type: z.enum(["vulnerability", "threat", "agent", "scan", "incident"]),
  severity: z.array(z.string()),
  channels: z.array(z.string()),
  recipients: z.array(z.string()),
  conditions: z.any(),
});

export const allSettingsSchema = z.object({
  general: generalSettingsSchema,
  security: securityPolicySchema,
  notifications: notificationSettingsSchema,
  alertRules: z.array(alertRuleSchema),
});

export const updateGeneralSettingsSchema = z.object({
  organizationName: z.string().optional(),
  timezone: z.string().optional(),
  dateFormat: z.string().optional(),
  timeFormat: z.string().optional(),
  language: z.string().optional(),
  defaultDashboard: z.string().optional(),
  maintenanceMode: z.boolean().optional(),
  maintenanceMessage: z.string().optional(),
  lastUsedExternalSourceId: z.string().nullable().optional(),
});

export const updateNotificationSettingsSchema = z.object({
  emailEnabled: z.boolean().optional(),
  emailServer: z.string().optional(),
  emailPort: z.number().optional(),
  emailSecure: z.boolean().optional(),
  emailFrom: z.string().optional(),
  slackEnabled: z.boolean().optional(),
  slackWebhookUrl: z.string().optional(),
  teamsEnabled: z.boolean().optional(),
  teamsWebhookUrl: z.string().optional(),
  webhookEnabled: z.boolean().optional(),
  webhookUrl: z.string().optional(),
  webhookHeaders: z.any().optional(),
});

// Data Policy: AI redaction rules and outbound data handling
export const dataPolicySchema = z.object({
  // Outbound data policy
  payloadClass: z.literal("incident_bundle"),
  payloadClassDescription: z.string(),
  rawDataOverride: z.boolean(),
  rawDataOverrideDescription: z.string(),

  // Redaction rules
  redactionRules: z.array(
    z.object({
      label: z.string(),
      description: z.string(),
    }),
  ),

  // Metadata
  version: z.string(),
  disclaimer: z.string(),
});
